<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="920px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <el-form ref="formRef" :model="form" :rules="rules" label-width="110px" size="small">
      <el-form-item v-if="isPositionScope" label="岗位" prop="stationName">
        <el-select v-model="form.stationName" placeholder="请选择岗位" style="width: 100%">
          <el-option v-for="s in configurableStations" :key="s.value" :label="s.label" :value="s.value" />
        </el-select>
      </el-form-item>

      <template v-if="isSpecialScope">
        <el-form-item label="配置对象" prop="targetType">
          <el-radio-group v-model="form.targetType" @change="onSpecialTargetTypeChange">
            <el-radio label="person">单个人员</el-radio>
            <el-radio label="group">人员组</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.targetType === 'person'" label="人员" prop="targetId">
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_User"
            :default-value="personUserId"
            :callback-params="{ key: 'userId' }"
            @parentCallBack="onUserSelected"
          />
        </el-form-item>
        <el-form-item v-else label="人员组" prop="targetId">
          <el-select v-model="form.targetId" filterable placeholder="请选择人员组" style="width: 100%">
            <el-option v-for="g in groupOptions" :key="g.uuid" :label="g.groupName" :value="g.uuid" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.targetType === 'person'" label="叠加模式">
          <el-radio-group v-model="form.overlapMode">
            <el-radio v-for="item in overlapModeOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>

      <el-form-item label="规则名称" prop="ruleName">
        <el-input v-model="form.ruleName" placeholder="例如：基础提成" />
      </el-form-item>
      <el-form-item label="计算类型" prop="calcType">
        <el-select v-model="form.calcType" style="width: 100%" @change="onCalcTypeChange">
          <el-option v-for="item in calcTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="form.calcType === 'percent'" label="提成比例(%)">
        <el-input-number v-model="form.percentRate" :min="0" :max="100" :precision="2" controls-position="right" />
      </el-form-item>

      <el-form-item v-if="form.calcType === 'fixed'" label="计入方式">
        <el-select v-model="form.bizCategoryCombineMode" style="width: 160px">
          <el-option v-for="item in bizCategoryCombineModeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <span class="tip-text">单独计算：该业务类型从总业务计提中剔除后单独算；累加计算：在总业务计提之外额外加上</span>
      </el-form-item>

      <el-form-item v-if="form.calcType === 'fixed'" label="业务分类设置">
        <div class="batch-rule-tip">
          每行配置一种业务类型：固定金额按「票数×金额」；提成比例按「计息毛利×比例」。
        </div>
        <el-table :key="'fixed-' + form.batchFixedConditionField" :data="form.batchFixedRules" border size="mini" class="batch-rule-table biz-category-table">
          <el-table-column width="240">
            <template slot="header">
              <el-select v-model="form.batchFixedConditionField" size="mini" style="width: 220px" @change="onBatchFixedConditionFieldChange">
                <el-option label="业务类型" value="lob" />
                <el-option label="自定义业务类型" value="customJobType" />
              </el-select>
            </template>
            <template slot-scope="scope">
              <el-select
                v-if="form.batchFixedConditionField === 'lob'"
                v-model="scope.row.conditionValues"
                multiple
                collapse-tags
                filterable
                placeholder="可多选业务类型"
                size="mini"
                style="width: 100%"
              >
                <el-option v-for="l in lobOptions" :key="l.value" :label="l.label" :value="l.value" />
              </el-select>
              <el-select
                v-else
                v-model="scope.row.conditionValues"
                multiple
                collapse-tags
                filterable
                allow-create
                placeholder="可多选类型"
                size="mini"
                style="width: 100%"
              >
                <el-option v-for="c in customJobTypeOptions" :key="c" :label="c + '类'" :value="c" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="计算方式" width="150">
            <template slot-scope="scope">
              <el-select v-model="scope.row.lineMode" size="mini" style="width: 100%" @change="onBatchLineModeChange(scope.row)">
                <el-option v-for="item in bizCategoryLineModeOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="数值" width="150">
            <template slot-scope="scope">
              <div class="value-with-unit">
                <el-input-number
                  v-if="scope.row.lineMode === 'profit'"
                  v-model="scope.row.rate"
                  :min="0"
                  :max="100"
                  :precision="2"
                  :controls="false"
                  size="mini"
                  style="width: 90px"
                />
                <el-input-number
                  v-else
                  v-model="scope.row.fixedAmount"
                  :min="0"
                  :precision="2"
                  :controls="false"
                  size="mini"
                  style="width: 90px"
                />
                <span class="value-unit">{{ scope.row.lineMode === 'profit' ? '%' : '元/单' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="70">
            <template slot-scope="scope">
              <el-button type="text" @click="removeBatchFixedRule(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="text" icon="el-icon-plus" @click="addBatchFixedRule">添加一档</el-button>
      </el-form-item>

      <template v-if="form.calcType === 'fixed_bonus'">
        <el-form-item label="计算方式">
          <el-select v-model="form.tierMode" style="width: 160px">
            <el-option v-for="item in tierModeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="奖励档位">
          <div class="batch-rule-tip">多档奖励保存在同一条规则内，按个人总票数或总毛利匹配档位。</div>
          <el-table :data="form.bonusTiers" border size="mini" class="batch-rule-table">
            <el-table-column label="下限" width="120">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.lowerLimit"
                  :min="0"
                  :precision="bonusTierPrecision"
                  :controls="false"
                  size="mini"
                  style="width: 100%"
                />
              </template>
            </el-table-column>
            <el-table-column label="上限" width="120">
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.upperLimit"
                  :min="0"
                  :precision="bonusTierPrecision"
                  :controls="false"
                  size="mini"
                  style="width: 100%"
                />
              </template>
            </el-table-column>
            <el-table-column label="奖励金额(元)" width="140">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.fixedAmount" :min="0" :precision="2" :controls="false" size="mini" style="width: 100%" />
              </template>
            </el-table-column>
            <el-table-column label="操作" width="70">
              <template slot-scope="scope">
                <el-button type="text" @click="removeBonusTier(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="text" icon="el-icon-plus" @click="addBonusTier">添加一档</el-button>
        </el-form-item>
      </template>

      <template v-if="form.calcType === 'tier'">
        <el-form-item label="阶梯模式">
          <el-select v-model="form.tierMode" style="width: 160px" @change="onTierModeChange">
            <el-option v-for="item in tierModeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <el-select v-model="form.progressiveMode" style="width: 160px; margin-left: 10px">
            <el-option v-for="item in progressiveModeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="阶梯设置">
          <el-table :key="'tier-' + form.tierMode" :data="form.tiers" border size="mini">
            <el-table-column label="下限" width="100">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.lowerLimit" :precision="tierPrecision" :controls="false" size="mini" />
              </template>
            </el-table-column>
            <el-table-column label="上限" width="100">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.upperLimit" :precision="tierPrecision" :controls="false" size="mini" />
              </template>
            </el-table-column>
            <el-table-column v-if="form.tierMode !== 'ticket'" label="比例(%)" width="100">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.rate" :controls="false" size="mini" />
              </template>
            </el-table-column>
            <el-table-column v-if="form.tierMode === 'ticket'" label="固定金额(元/票)" width="120">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.fixedAmount" :controls="false" size="mini" />
              </template>
            </el-table-column>
            <el-table-column label="操作" width="70">
              <template slot-scope="scope">
                <el-button type="text" @click="removeTier(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="text" icon="el-icon-plus" @click="addTier">添加阶梯</el-button>
        </el-form-item>
      </template>

      <template v-if="form.calcType === 'team'">
        <el-form-item label="人员组">
          <el-select v-model="form.teamGroupUuid" filterable style="width: 100%">
            <el-option v-for="g in groupOptions" :key="g.uuid" :label="g.groupName" :value="g.uuid" />
          </el-select>
        </el-form-item>
        <el-form-item label="扣减基数X(元)">
          <el-input-number v-model="form.teamDeductBase" :min="0" :precision="2" controls-position="right" />
        </el-form-item>
        <el-form-item label="提成比例Y(%)">
          <el-input-number v-model="form.teamPercentRate" :min="0" :max="100" :precision="2" controls-position="right" />
        </el-form-item>
        <el-form-item label=" ">
          <div class="formula-tip">
            <div class="formula-title">计算公式：</div>
            <div class="formula-line">计提金额 = (组内<strong>他人</strong>毛利合计 - 人数 × X) × Y%</div>
            <div class="formula-note">「他人」=所选人员组内，除当前计提人员外的所有成员</div>
            <div class="formula-note">括号内结果若为负数则计提金额按 0 计算</div>
            <div class="formula-example">例：组内3人，他人毛利合计 12000，X=2000，Y=10%</div>
            <div class="formula-example">→ (12000 - 3×2000) × 10% = 6000 × 10% = 600</div>
          </div>
        </el-form-item>
      </template>

      <el-form-item label="适用条件">
        <div v-for="(cond, idx) in form.conditions" :key="idx" class="condition-row">
          <el-select v-model="cond.fieldName" placeholder="请选择字段" style="width: 160px" @change="onConditionFieldChange(cond)">
            <el-option v-for="item in conditionFieldOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <template v-if="cond.fieldName && isMultiValueField(cond.fieldName)">
            <span class="cond-label" style="margin: 0 6px">等于(可多选)</span>
            <el-select v-if="cond.fieldName === 'customJobType'" v-model="cond.fieldValueArr" multiple filterable allow-create placeholder="选择业务类型" style="width: 260px">
              <el-option v-for="c in customJobTypeOptions" :key="c" :label="c + '类'" :value="c" />
            </el-select>
            <el-select v-else-if="cond.fieldName === 'customerType'" v-model="cond.fieldValueArr" multiple placeholder="选择客户类型" style="width: 260px">
              <el-option v-for="r in customerTypeOptions" :key="r.value" :label="r.label" :value="r.value" />
            </el-select>
            <el-select v-else v-model="cond.fieldValueArr" multiple filterable allow-create placeholder="选择业务类型" style="width: 260px">
              <el-option v-for="l in lobOptions" :key="l.value" :label="l.label" :value="l.value" />
            </el-select>
          </template>
          <template v-else-if="isNumericConditionField(cond.fieldName)">
            <el-select v-model="cond.operator" style="width: 80px; margin: 0 6px">
              <el-option label=">=" value=">=" />
              <el-option label="<=" value="<=" />
              <el-option label="=" value="=" />
              <el-option label=">" value=">" />
              <el-option label="<" value="<" />
            </el-select>
            <el-input v-model="cond.fieldValue" placeholder="数值" style="width: 120px" />
          </template>
          <span v-else class="cond-label" style="margin: 0 6px; color: #C0C4CC;">← 请选择字段</span>
          <el-button type="text" @click="form.conditions.splice(idx, 1)">删除</el-button>
        </div>
        <el-button type="text" icon="el-icon-plus" @click="addCondition">添加条件</el-button>
      </el-form-item>

      <el-form-item label="生效日期">
        <el-date-picker v-model="form.effectiveDate" type="date" value-format="yyyy-MM-dd" style="width: 160px" />
        <span style="margin: 0 8px">至</span>
        <el-date-picker v-model="form.expireDate" type="date" value-format="yyyy-MM-dd" style="width: 160px" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveRule, getRuleDetail, savePersonRuleConfig, getPersonRuleConfig } from '@/api/provision/provisionRule'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as ProvisionConstants from '@/class/cargo/model/parameters/ProvisionConstants'

export default {
  name: 'RuleEditDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, default: false },
    ruleUuid: { type: String, default: '' },
    scope: { type: String, default: 'position' },
    groupOptions: { type: Array, default: () => [] }
  },
  data() {
    return {
      configurableStations: ProvisionConstants.CONFIGURABLE_STATIONS,
      allCalcTypeOptions: ProvisionConstants.CALC_TYPE_OPTIONS,
      tierModeOptions: ProvisionConstants.TIER_MODE_OPTIONS,
      progressiveModeOptions: ProvisionConstants.PROGRESSIVE_MODE_OPTIONS,
      conditionFieldOptions: ProvisionConstants.CONDITION_FIELD_OPTIONS,
      customJobTypeOptions: ProvisionConstants.CUSTOM_JOB_TYPE_OPTIONS,
      lobOptions: ProvisionConstants.LOB_OPTIONS,
      customerTypeOptions: ProvisionConstants.CUSTOMER_TYPE_OPTIONS,
      overlapModeOptions: ProvisionConstants.OVERLAP_MODE_OPTIONS,
      bizCategoryLineModeOptions: ProvisionConstants.BIZ_CATEGORY_LINE_MODE_OPTIONS,
      bizCategoryCombineModeOptions: ProvisionConstants.BIZ_CATEGORY_COMBINE_MODE_OPTIONS,
      selectTypeNames: TYPE_NAMES,
      personUserId: null,
      form: this.defaultForm()
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    },
    dialogTitle() {
      return this.ruleUuid ? '编辑规则' : '新增规则'
    },
    isPositionScope() {
      return this.scope === 'position'
    },
    isSpecialScope() {
      return this.scope === 'special'
    },
    calcTypeOptions() {
      if (this.isPositionScope) {
        return this.allCalcTypeOptions.filter(item => item.value !== 'team')
      }
      return this.allCalcTypeOptions
    },
    showBatchFixedRules() {
      return this.form.calcType === 'fixed'
    },
    bonusTierPrecision() {
      return this.form.tierMode === 'ticket' ? 0 : 2
    },
    tierPrecision() {
      return this.form.tierMode === 'ticket' ? 0 : 2
    },
    rules() {
      const r = {
        calcType: [{ required: true, message: '请选择计算类型', trigger: 'change' }],
        ruleName: [{ required: true, message: '请输入规则名称', trigger: 'blur' }]
      }
      if (this.isPositionScope) {
        r.stationName = [{ required: true, message: '请选择岗位', trigger: 'change' }]
      }
      if (this.isSpecialScope) {
        r.targetType = [{ required: true, message: '请选择配置对象', trigger: 'change' }]
        r.targetId = [{ required: true, message: '请选择人员或人员组', trigger: 'change' }]
      }
      return r
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadDetail()
      }
    }
  },
  mounted() {
    if (this.visible) {
      this.loadDetail()
    }
  },
  methods: {
    defaultForm() {
      return {
        uuid: '',
        ruleName: '',
        targetType: 'position',
        stationName: '',
        targetId: '',
        calcType: 'percent',
        status: '1',
        effectiveDate: '',
        expireDate: '',
        percentRate: 5,
        fixedAmount: 0,
        teamGroupUuid: '',
        teamDeductBase: 0,
        teamPercentRate: 0,
        tierMode: 'profit',
        progressiveMode: 'full',
        tiers: [],
        conditions: [],
        enableBatchFixedRules: false,
        batchFixedConditionField: 'lob',
        batchFixedRules: [],
        bizCategoryCombineMode: 'additive',
        bonusTiers: [],
        overlapMode: 'overlap'
      }
    },
    async loadDetail() {
      this.form = this.defaultForm()
      this.personUserId = null
      if (this.isPositionScope) {
        this.form.targetType = 'position'
      } else {
        this.form.targetType = 'person'
        this.form.stationName = ''
      }
      if (this.ruleUuid) {
        const res = await getRuleDetail(this.ruleUuid)
        if (res.ok && res.data) {
          Object.assign(this.form, res.data)
          if (!this.form.tiers) this.form.tiers = []
          if (!this.form.conditions) this.form.conditions = []
          this.form.conditions.forEach(c => {
            if (this.isMultiValueField(c.fieldName)) {
              c.operator = 'in'
              c.fieldValueArr = c.fieldValue ? c.fieldValue.split(',').map(v => v.trim()).filter(v => v) : []
            } else if (!c.fieldValueArr) {
              c.fieldValueArr = []
            }
          })
          if (this.form.targetType === 'person' && this.form.targetId) {
            this.personUserId = this.form.targetId
            await this.loadPersonOverlapMode(this.form.targetId)
          }
          this.normalizeLoadedRuleDetail()
        }
      } else if (this.form.calcType === 'fixed_bonus') {
        this.ensureBonusTierDefaults()
      }
    },
    normalizeLoadedRuleDetail() {
      if (this.form.calcType === 'fixed_bonus') {
        this.ensureBonusTierDefaults()
        if ((!this.form.bonusTiers || !this.form.bonusTiers.length) && this.form.tiers && this.form.tiers.length) {
          this.form.bonusTiers = this.form.tiers.map(t => ({ ...t }))
        }
        if ((!this.form.bonusTiers || !this.form.bonusTiers.length) && this.form.fixedAmount) {
          this.form.bonusTiers = [{ lowerLimit: 0, upperLimit: null, rate: 0, fixedAmount: this.form.fixedAmount }]
        }
        this.form.tiers = []
        return
      }
      if (this.form.calcType === 'fixed' && this.isFixedMultiTierData(this.form.tiers)) {
        const firstTier = this.form.tiers[0] || {}
        this.form.batchFixedConditionField = this.tierConditionField(firstTier) || 'lob'
        this.form.batchFixedRules = this.form.tiers.map(t => ({
          conditionValues: this.tierConditionValue(t)
            ? this.tierConditionValue(t).split(',').map(v => v.trim()).filter(v => v)
            : [],
          lineMode: t.lineMode || (this.hasNumber(t.rate) ? 'profit' : 'ticket'),
          fixedAmount: t.fixedAmount || 0,
          rate: t.rate || 0
        }))
        this.form.bizCategoryCombineMode = (this.form.tiers.find(t => t.combineMode) || {}).combineMode || 'additive'
        this.form.tiers = []
      } else if (this.form.calcType === 'fixed' && (!this.form.batchFixedRules || !this.form.batchFixedRules.length)) {
        this.form.batchFixedRules = [this.createEmptyBatchFixedRule()]
      }
    },
    tierConditionField(tier) {
      if (!tier) return ''
      return tier.conditionField || tier.condition_field || ''
    },
    tierConditionValue(tier) {
      if (!tier) return ''
      return tier.conditionValue || tier.condition_value || ''
    },
    isFixedMultiTierData(tiers) {
      if (!tiers || !tiers.length) return false
      if (tiers.some(t => this.tierConditionField(t) || this.tierConditionValue(t))) return true
      return tiers.every(t => !this.hasNumber(t.lowerLimit) && !this.hasNumber(t.upperLimit) && !this.hasNumber(t.rate))
    },
    ensureBonusTierDefaults() {
      if (!this.form.tierMode) this.form.tierMode = 'profit'
      if (!this.form.bonusTiers) this.form.bonusTiers = []
      if (!this.ruleUuid && !this.form.bonusTiers.length) {
        this.form.bonusTiers = [{ lowerLimit: 0, upperLimit: null, rate: 0, fixedAmount: 0 }]
      }
    },
    async loadPersonOverlapMode(userId) {
      try {
        const res = await getPersonRuleConfig(String(userId))
        if (res.ok && res.data && res.data.overlapMode) {
          this.form.overlapMode = res.data.overlapMode
        }
      } catch (e) {
        console.warn('loadPersonOverlapMode failed', e)
      }
    },
    onSpecialTargetTypeChange() {
      this.form.targetId = ''
      this.personUserId = null
    },
    onUserSelected(data) {
      if (!data) return
      const userId = data.key === 'userId' ? data.value : (data.value || data.userId)
      this.form.targetId = userId ? String(userId) : ''
      this.personUserId = userId || null
      if (this.form.targetId) {
        this.loadPersonOverlapMode(this.form.targetId)
      }
    },
    onCalcTypeChange() {
      if (this.form.calcType === 'fixed') {
        if (!this.form.batchFixedRules.length) {
          this.form.batchFixedRules = [this.createEmptyBatchFixedRule()]
        }
      } else {
        this.form.batchFixedRules = []
      }
      if (this.form.calcType === 'fixed_bonus') {
        this.ensureBonusTierDefaults()
      } else if (this.form.calcType !== 'tier') {
        this.form.tiers = []
        this.form.bonusTiers = []
      }
    },
    createEmptyBatchFixedRule() {
      return {
        conditionValues: [],
        lineMode: 'ticket',
        fixedAmount: 0,
        rate: 0
      }
    },
    onBatchLineModeChange(row) {
      if (row.lineMode === 'profit') {
        row.fixedAmount = 0
      } else {
        row.rate = 0
      }
    },
    onBatchFixedConditionFieldChange() {
      this.form.batchFixedRules.forEach(row => {
        row.conditionValues = []
      })
    },
    addBatchFixedRule() {
      this.form.batchFixedRules.push(this.createEmptyBatchFixedRule())
    },
    removeBatchFixedRule(index) {
      this.form.batchFixedRules.splice(index, 1)
    },
    addBonusTier() {
      this.form.bonusTiers.push({ lowerLimit: 0, upperLimit: null, rate: 0, fixedAmount: 0 })
    },
    removeBonusTier(index) {
      this.form.bonusTiers.splice(index, 1)
    },
    addTier() {
      this.form.tiers.push({ lowerLimit: 0, upperLimit: null, rate: 0, fixedAmount: 0 })
    },
    removeTier(index) {
      this.form.tiers.splice(index, 1)
    },
    onTierModeChange() {
      const keepRate = this.form.tierMode !== 'ticket'
      ;(this.form.tiers || []).forEach(t => {
        if (keepRate) t.fixedAmount = 0
        else t.rate = 0
      })
    },
    addCondition() {
      this.form.conditions.push({ fieldName: '', operator: '', fieldValue: '', fieldValueArr: [] })
    },
    isMultiValueField(fieldName) {
      return fieldName === 'customJobType' || fieldName === 'lob' || fieldName === 'customerType'
    },
    isNumericConditionField(fieldName) {
      return ['profit', 'personalProfitTotal', 'personalTicketTotal'].includes(fieldName)
    },
    onConditionFieldChange(cond) {
      cond.fieldValue = ''
      cond.fieldValueArr = []
      if (this.isMultiValueField(cond.fieldName)) {
        cond.operator = 'in'
      } else if (this.isNumericConditionField(cond.fieldName)) {
        cond.operator = '>='
      } else {
        cond.operator = ''
      }
      this.$forceUpdate()
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate()
      } catch (e) {
        return
      }
      if (this.isSpecialScope && !this.form.targetId) {
        this.$message.warning(this.form.targetType === 'person' ? '请选择人员' : '请选择人员组')
        return
      }
      const payloadConditions = this.form.conditions.filter(c => c.fieldName).map(c => {
        if (this.isMultiValueField(c.fieldName)) {
          const arr = (c.fieldValueArr || []).filter(v => v)
          return { fieldName: c.fieldName, operator: 'in', fieldValue: arr.join(',') }
        }
        return { fieldName: c.fieldName, operator: c.operator, fieldValue: c.fieldValue }
      })
      const targetType = this.isPositionScope ? 'position' : this.form.targetType
      const basePayload = {
        ...this.form,
        conditions: payloadConditions,
        targetType,
        stationName: this.isPositionScope ? this.form.stationName : '',
        targetId: this.isSpecialScope ? String(this.form.targetId) : ''
      }
      delete basePayload.enableBatchFixedRules
      delete basePayload.batchFixedConditionField
      delete basePayload.batchFixedRules
      delete basePayload.bonusTiers
      const payload = this.buildSubmitPayload(basePayload)
      if (!payload) return
      const res = await saveRule(payload)
      if (res.ok) {
        if (this.isSpecialScope && this.form.targetType === 'person' && this.form.targetId) {
          await savePersonRuleConfig(String(this.form.targetId), '1', this.form.overlapMode || 'overlap')
        }
        this.$message.success('保存成功')
        this.$emit('success')
        this.dialogVisible = false
      }
    },
    buildSubmitPayload(basePayload) {
      if (this.form.calcType === 'fixed_bonus') {
        const tiers = (this.form.bonusTiers || []).filter(t => this.hasNumber(t.lowerLimit) || this.hasNumber(t.fixedAmount))
        if (!tiers.length) {
          this.$message.warning('请至少添加一档奖励')
          return null
        }
        if (!this.validateBonusTiers(tiers)) {
          return null
        }
        return {
          ...basePayload,
          fixedAmount: 0,
          progressiveMode: 'full',
          tiers: tiers.map(t => ({
            lowerLimit: t.lowerLimit,
            upperLimit: t.upperLimit,
            rate: 0,
            fixedAmount: t.fixedAmount || 0
          })),
          conditions: (basePayload.conditions || []).filter(c => !['personalTicketTotal', 'personalProfitTotal'].includes(c.fieldName))
        }
      }
      if (this.form.calcType === 'fixed' || this.showBatchFixedRules || this.isFixedMultiTierData(this.form.tiers)) {
        const rows = (this.form.batchFixedRules || []).filter(row => row.conditionValues && row.conditionValues.length)
        if (!rows.length) {
          this.$message.warning('请至少填写一档业务分类规则')
          return null
        }
        for (const row of rows) {
          if (row.lineMode === 'profit') {
            if (!this.hasNumber(row.rate) || Number(row.rate) <= 0) {
              this.$message.warning('请填写大于0的提成比例')
              return null
            }
          } else if (!this.hasNumber(row.fixedAmount) || Number(row.fixedAmount) <= 0) {
            this.$message.warning('请填写大于0的固定金额')
            return null
          }
        }
        const duplicated = rows
          .map(row => (row.conditionValues || []).slice().sort().join(','))
          .find((key, index, arr) => arr.indexOf(key) !== index)
        if (duplicated) {
          this.$message.warning('业务分类适用条件不能重复')
          return null
        }
        return {
          ...basePayload,
          fixedAmount: 0,
          tiers: rows.map(row => ({
            lowerLimit: null,
            upperLimit: null,
            rate: row.lineMode === 'profit' ? (row.rate || 0) : null,
            fixedAmount: row.lineMode === 'profit' ? 0 : (row.fixedAmount || 0),
            lineMode: row.lineMode || 'ticket',
            combineMode: this.form.bizCategoryCombineMode || 'additive',
            conditionField: this.form.batchFixedConditionField,
            conditionValue: (row.conditionValues || []).join(',')
          })),
          conditions: (basePayload.conditions || []).filter(c => !this.isBatchManagedCondition(c.fieldName))
        }
      }
      if (this.form.calcType === 'tier') {
        return {
          ...basePayload,
          tiers: this.form.tiers || []
        }
      }
      return {
        ...basePayload,
        tiers: []
      }
    },
    isBatchManagedCondition(fieldName) {
      return ['lob', 'customJobType', 'personalTicketTotal', 'personalProfitTotal'].includes(fieldName)
    },
    hasNumber(value) {
      return value !== null && typeof value !== 'undefined' && value !== ''
    },
    validateBonusTiers(tiers) {
      const ranges = tiers.map(tier => ({
        lower: Number(tier.lowerLimit),
        upper: this.hasNumber(tier.upperLimit) ? Number(tier.upperLimit) : null
      })).sort((a, b) => a.lower - b.lower)
      for (const range of ranges) {
        if (range.upper !== null && range.upper <= range.lower) {
          this.$message.warning('奖励档位上限必须大于下限')
          return false
        }
      }
      for (let i = 1; i < ranges.length; i++) {
        const prev = ranges[i - 1]
        const current = ranges[i]
        if (prev.upper === null || current.lower < prev.upper) {
          this.$message.warning('奖励档位区间不能重叠')
          return false
        }
      }
      return true
    },
    handleClose() {
      this.form = this.defaultForm()
      this.personUserId = null
    }
  }
}
</script>

<style scoped>
.condition-row { margin-bottom: 6px; }
.cond-label { color: #606266; font-size: 12px; }
.tip-text { margin-left: 8px; color: #909399; font-size: 12px; }
.batch-rule-tip { color: #909399; font-size: 12px; margin-bottom: 6px; }
.batch-rule-table { margin-bottom: 4px; }
.biz-category-table {
  width: fit-content;
  max-width: 100%;
}
.biz-category-table >>> colgroup col[name='gutter'] {
  width: 0 !important;
  display: none;
}
.biz-category-table >>> .gutter {
  display: none;
}
.value-with-unit {
  display: flex;
  align-items: center;
  gap: 4px;
}
.value-unit {
  color: #606266;
  font-size: 12px;
  white-space: nowrap;
}
.formula-tip {
  background: #f5f7fa;
  border-left: 3px solid #409EFF;
  padding: 10px 14px;
  border-radius: 2px;
  font-size: 12px;
  line-height: 1.8;
  color: #606266;
}
.formula-title { font-weight: 600; color: #303133; margin-bottom: 4px; }
.formula-line { font-weight: 600; color: #303133; }
.formula-note { color: #909399; }
.formula-example { color: #67C23A; }
</style>
